import { call, put, takeEvery } from "redux-saga/effects"
import Swal from "sweetalert2"

// Crypto Redux States
import {
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST,
  GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL,
  ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER,
  UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER,
  DELETE_GOOD_SERVICES_SUB_HEAD_MASTER,
} from "./actionTypes"
import {
  getGoodServicesSubHeadMasterListSuccess,
  getGoodServicesSubHeadMasterListFail,
  getGoodServicesSubHeadMasterDetailSuccess,
  getGoodServicesSubHeadMasterDetailFail,
  addNewGoodServicesSubHeadMasterSuccess,
  addNewGoodServicesSubHeadMasterFail,
  updateGoodServicesSubHeadMasterSuccess,
  updateGoodServicesSubHeadMasterFail,
  deleteGoodServicesSubHeadMasterSuccess,
  deleteGoodServicesSubHeadMasterFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getGoodServicesSubHeadMasterList,
  getGoodServicesSubHeadMasterDetail,
  addNewGoodServicesSubHeadMaster,
  updateGoodServicesSubHeadMaster,
  deleteGoodServicesSubHeadMaster,
} from "helpers/fakebackend_helper"

function* fetchGoodServicesSubHeadMasterList() {
  try {
    const response = yield call(getGoodServicesSubHeadMasterList)
    yield put(getGoodServicesSubHeadMasterListSuccess(response))
  } catch (error) {
    yield put(getGoodServicesSubHeadMasterListFail(error))
  }
}

function* fetchGoodServicesSubHeadMasterDetail({ goodServicesSubHeadId }) {
  try {
    const response = yield call(getGoodServicesSubHeadMasterDetail, goodServicesSubHeadId)
    yield put(getGoodServicesSubHeadMasterDetailSuccess(response))
  } catch (error) {
    yield put(getGoodServicesSubHeadMasterDetailFail(error))
  }
}

function* onAddNewGoodServicesSubHeadMaster({ payload: { goodServicesSubHead, history } }) {
  try {
    const response = yield call(addNewGoodServicesSubHeadMaster, goodServicesSubHead)
    if (response.status === true) {
      yield put(addNewGoodServicesSubHeadMasterSuccess(response))
      Swal.fire({
        title: "Success",
        icon: "success",
        text: "Your Goods Services Sub Head Master Has Been Created.",
      }).then(result => {
        if (result.isConfirmed) {
          history("/settings/goods-services-sub-head-master")
        }
      })
    } else {
      throw new Error(
        response && response.message ? response.message : "Unknown error"
      )
    }
  } catch (error) {
    yield put(addNewGoodServicesSubHeadMasterFail(error))
    Swal.fire({
      title: "failure",
      icon: "error",
      text: error.message || "Unknown error",
    })
  }
}

function* onUpdateGoodServicesSubHeadMaster({ payload: { id, goodServicesSubHead, history } }) {
  try {
    const response = yield call(updateGoodServicesSubHeadMaster, id, goodServicesSubHead)
    if (response && response.status === true) {
      yield put(updateGoodServicesSubHeadMasterSuccess(response))
      Swal.fire({
        title: "Success",
        icon: "success",
        text: "Your Sevice Sub Head  Master Has Been Updated.",
      }).then(result => {
        if (result.isConfirmed) {
          history("/settings/goods-services-sub-head-master")
        }
      })
    } else {
      throw new Error(
        response && response.message ? response.message : "Unknown error"
      )
    }
  } catch (error) {
    yield put(updateGoodServicesSubHeadMasterFail(error))
    Swal.fire({
      title: "Failure",
      icon: "error",
      text: error.message || "Unknown error",
    })
  }
}

function* onDeleteGoodServicesSubHeadMaster({ payload: goodServicesSubHead }) {
  try {
    const response = yield call(deleteGoodServicesSubHeadMaster, goodServicesSubHead)
    const response2 = yield put(deleteGoodServicesSubHeadMasterSuccess(response))
    // yield put(deleteSACHSNCodeSuccess(response))
    if (response2.payload.status) {
      const goodServicesSubHeadMasterListResponse = yield call(getGoodServicesSubHeadMasterList)
      yield put(getGoodServicesSubHeadMasterListSuccess(goodServicesSubHeadMasterListResponse))
    } else {
      console.error("Error in delete GoodServicesSubHead Master:", response.error)
    }
  } catch (error) {
    yield put(deleteGoodServicesSubHeadMasterFail(error))
  }
}

function* goodServicesSubHeadMasterSaga() {
  yield takeEvery(GET_GOOD_SERVICES_SUB_HEAD_MASTER_LIST, fetchGoodServicesSubHeadMasterList)
  yield takeEvery(GET_GOOD_SERVICES_SUB_HEAD_MASTER_DETAIL, fetchGoodServicesSubHeadMasterDetail)
  yield takeEvery(ADD_NEW_GOOD_SERVICES_SUB_HEAD_MASTER, onAddNewGoodServicesSubHeadMaster)
  yield takeEvery(UPDATE_GOOD_SERVICES_SUB_HEAD_MASTER, onUpdateGoodServicesSubHeadMaster)
  yield takeEvery(DELETE_GOOD_SERVICES_SUB_HEAD_MASTER, onDeleteGoodServicesSubHeadMaster)
}

export default goodServicesSubHeadMasterSaga
